"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
export class Controller {
  constructor() {
    this._visible = false;
  }
  set visible(visible) {
    this._visible = visible;
  }
  get visible() {
    return this._visible;
  }
}
let UiDrawer = class extends Vue {
  show() {
    this._controller.visible = true;
  }
  close() {
    this.$emit("close");
    this._controller.visible = false;
  }
  closed() {
    this.$emit("close");
  }
};
__decorateClass([
  PropSync("controller", {
    default: () => {
      return new Controller();
    }
  })
], UiDrawer.prototype, "_controller", 2);
UiDrawer = __decorateClass([
  Component({
    components: {}
  })
], UiDrawer);
export {
  UiDrawer as default
};
